module.exports = __webpack_public_path__ + "img/11087929_L.8bf29603.png";